import { LinkButton } from "@/components/Elements/Inputs/Buttons/LinkButton";
import { UserText } from "@/components/Elements/Texts/UserText";
import { valuatedState } from "@/store/propertyState";
import { RealtorState } from "@/store/realtorState";
import { useEffect } from "react";
import { useRecoilState } from "recoil";

export const ResultMain = () => {
  const [realtor] = useRecoilState(RealtorState);
  const [valuated] = useRecoilState(valuatedState);

  // 戻るを無効にする
  useEffect(() => {
    window.history.pushState(null, "", null); // 無効なブラウザ履歴を追加
    window.addEventListener("popstate", function () {
      window.history.pushState(null, "", null);
      return;
    });
  }, []);

  // エラー排他処理
  if(realtor.display == undefined)return <></>

  return (
    <>
      {valuated.trend ? <>ここにグラフを表示</> : <></>}

      <UserText>ご利用ありがとうございました</UserText>

      
      {
        realtor.display.result_url ? 
        <>
        <UserText>
          より詳細な査定や売却をご希望の方は以下のボタンよりお問い合わせください
        </UserText>
        <LinkButton
          label="詳細な査定や売却希望の方はこちら"
          href={realtor.link.access}
          color={realtor.color.main}
        ></LinkButton></> :<></>
      }
      
    </>
  );
};
